import { getTranslationsForLocale, } from "@tv4/avod-web-player-common";
const langDisplayNames = {
    sv: new Intl.DisplayNames("sv", { type: "language" }),
    fi: new Intl.DisplayNames("fi", { type: "language" }),
};
export function getLanguageDisplayName(locale, languageCode) {
    const legacyCustomCodes = {
        nl: "language__nl", // nl means heard of hearing for MTV
        qaa: "language__qaa",
        qaf: "language__qaf",
        qag: "language__qag",
        qai: "language__qai",
        qas: "language__qas",
        qol: "language__qol",
        qd: "language_qd",
        qad: "language_qad",
        qhi: "language_qhi",
        qvi: "language_qvi",
    };
    if (languageCode in legacyCustomCodes) {
        const translation = getTranslationsForLocale(locale);
        return translation(legacyCustomCodes[languageCode]);
    }
    try {
        const lcLanguage = langDisplayNames[locale].of(languageCode);
        if (lcLanguage) {
            return lcLanguage.charAt(0).toUpperCase() + lcLanguage.slice(1);
        }
    }
    catch (error) {
        console.warn("Received invalid language code", languageCode, "Which resulted in error", error);
    }
    return languageCode;
}
